var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { asEnumerable } from "linq-es2015";
import { PollinationCategoryEnum } from "./pollination-category.service";
import { ConjunctionEnum } from "../models/conjunction.enum";
var PollinationStakeLabelService = /** @class */ (function () {
    function PollinationStakeLabelService() {
    }
    PollinationStakeLabelService.prototype.getGroupConjunction = function (groupIndex, conjunction, hasCategory) {
        if (groupIndex === 0) {
            return "";
        }
        if (!hasCategory) {
            return conjunction === ConjunctionEnum.And ? "&" : "/";
        }
        return "";
    };
    PollinationStakeLabelService.prototype.createStakeLabel = function (items, pollinationCategoryId, pollinationCategoryName) {
        var categoryId = pollinationCategoryId;
        switch (categoryId) {
            case PollinationCategoryEnum.ZygosityDependent:
                return 'Zygosity-dependent';
            case PollinationCategoryEnum.CrossingBlock:
                return 'Crossing block';
            case PollinationCategoryEnum.Standard:
                return this.createStandardStakeLabel(items, pollinationCategoryName || '');
            default:
                if (!pollinationCategoryId && !pollinationCategoryName) {
                    return this.createStandardStakeLabel(items, '');
                }
                return '';
        }
    };
    PollinationStakeLabelService.prototype.createStandardStakeLabel = function (items, categoryName) {
        var _this = this;
        var processedItems = items.map(function (i) {
            var processed = __assign({}, i);
            switch (i.pollinationType) {
                case PollinationTypeEnum.Self:
                    processed.truncatedPollinationType = "SLF";
                    break;
                case PollinationTypeEnum.Sibling:
                    processed.truncatedPollinationType = "SIB";
                    break;
                case PollinationTypeEnum.CarryTo:
                    processed.truncatedPollinationType = _this.truncate("XOT:" + i.geName, 21);
                    break;
                case PollinationTypeEnum.CarryFrom:
                    processed.truncatedPollinationType = _this.truncate("XIN:" + i.geName, 21);
                    break;
                case PollinationTypeEnum.SelfSibling:
                    processed.truncatedPollinationType = "(SLF/SIB)";
                    break;
                case PollinationTypeEnum.None:
                    processed.truncatedPollinationType = "None";
                    break;
                default:
                    processed.truncatedPollinationType = "";
                    break;
            }
            return processed;
        });
        var validItems = processedItems.filter(function (i) { return i.truncatedPollinationType && i.truncatedPollinationType.trim() !== ""; });
        var groupedItems = asEnumerable(validItems)
            .GroupBy(function (g) { return g.groupIndex; })
            .ToArray();
        var isLegacyRequest = categoryName === '';
        if (isLegacyRequest) {
            var fullStakeLabel = asEnumerable(groupedItems)
                .Select(function (g) {
                var firstItem = asEnumerable(g).First();
                var groupConjunction = firstItem.groupConjunction;
                var itemLabels = asEnumerable(g)
                    .OrderBy(function (i) { return i.itemIndex; })
                    .Select(function (i) { return "" + i.itemConjunction + i.truncatedPollinationType; })
                    .ToArray();
                var groupContent = itemLabels.join("");
                var needsParentheses = groupedItems.length > 1 || itemLabels.length > 1;
                return needsParentheses ?
                    groupConjunction + "(" + groupContent + ")" :
                    "" + groupConjunction + groupContent;
            })
                .ToArray()
                .join("");
            return this.truncate(fullStakeLabel, 60);
        }
        return this.createStandardCategoryLabel(groupedItems);
    };
    PollinationStakeLabelService.prototype.createStandardCategoryLabel = function (groupedItems) {
        var lines = [];
        var primaryGroup = groupedItems.find(function (g) {
            var firstItem = asEnumerable(g).First();
            return firstItem.groupIndex === 0;
        });
        var secondaryGroup = groupedItems.find(function (g) {
            var firstItem = asEnumerable(g).First();
            return firstItem.groupIndex === 1;
        });
        var primaryContent = "";
        var hasValidPrimaryInstructions = false;
        if (primaryGroup) {
            var primaryLabels = asEnumerable(primaryGroup)
                .OrderBy(function (item) { return item.itemIndex; })
                .Select(function (item) { return "" + item.itemConjunction + item.truncatedPollinationType; })
                .ToArray();
            primaryContent = primaryLabels.join("");
            hasValidPrimaryInstructions = primaryContent.trim() !== "";
        }
        var secondaryContent = "";
        var hasValidSecondaryInstructions = false;
        var primaryConjunction = "";
        if (secondaryGroup) {
            var secondaryLabels = asEnumerable(secondaryGroup)
                .OrderBy(function (item) { return item.itemIndex; })
                .Select(function (item) { return "" + item.itemConjunction + item.truncatedPollinationType; })
                .ToArray();
            secondaryContent = secondaryLabels.join("");
            hasValidSecondaryInstructions = secondaryContent.trim() !== "";
            if (hasValidPrimaryInstructions && hasValidSecondaryInstructions) {
                var firstSecondaryItem = asEnumerable(secondaryGroup).First();
                var groupConjunction = firstSecondaryItem.groupConjunction;
                primaryConjunction = groupConjunction === "&" ? "&" : (groupConjunction === "/" ? "/" : "");
            }
        }
        if (hasValidPrimaryInstructions) {
            var needsParentheses = primaryGroup && asEnumerable(primaryGroup).Count() > 1;
            var formattedPrimaryContent = needsParentheses ? "(" + primaryContent + ")" : primaryContent;
            lines.push("Primary Standard: " + formattedPrimaryContent + primaryConjunction);
        }
        else {
            lines.push("Primary Standard:");
        }
        if (hasValidSecondaryInstructions) {
            var needsParentheses = secondaryGroup && asEnumerable(secondaryGroup).Count() > 1;
            var formattedSecondaryContent = needsParentheses ? "(" + secondaryContent + ")" : secondaryContent;
            lines.push("Secondary Standard: " + formattedSecondaryContent);
        }
        else {
            lines.push("Secondary Standard:");
        }
        return lines.join("\n             ");
    };
    PollinationStakeLabelService.prototype.truncate = function (input, maxLength) {
        if (input === null || input.length <= maxLength)
            return input;
        return input.substring(0, maxLength - 1) + "!";
    };
    return PollinationStakeLabelService;
}());
export { PollinationStakeLabelService };
var PollinationStakeLabelItemData = /** @class */ (function () {
    function PollinationStakeLabelItemData() {
    }
    return PollinationStakeLabelItemData;
}());
export { PollinationStakeLabelItemData };
export var PollinationTypeEnum;
(function (PollinationTypeEnum) {
    PollinationTypeEnum[PollinationTypeEnum["Self"] = 1] = "Self";
    PollinationTypeEnum[PollinationTypeEnum["Sibling"] = 2] = "Sibling";
    PollinationTypeEnum[PollinationTypeEnum["CarryTo"] = 3] = "CarryTo";
    PollinationTypeEnum[PollinationTypeEnum["CarryFrom"] = 4] = "CarryFrom";
    PollinationTypeEnum[PollinationTypeEnum["SelfSibling"] = 5] = "SelfSibling";
    PollinationTypeEnum[PollinationTypeEnum["None"] = 6] = "None";
})(PollinationTypeEnum || (PollinationTypeEnum = {}));



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/pollination-stake-label.service.ts.pre-build-optimizer.js